/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages

        var menuList, mobileToggle;
        mobileToggle = $('.header__menu_link');
        mobileClose = $('.header__menu_top .close-icon');
        menuList = $('.header__menu');

        mobileToggle.on("click", function (e) {
          e.preventDefault();
          menuList.slideToggle();
        });

        mobileClose.on("click", function (e) {
          e.preventDefault();
          menuList.slideToggle();
        });
        // // var upButton = document.getElementById("up-button");
        // $("#up-button").click(function () {
        //   TweenMax.to(window, 2, { scrollTo: { y: "#footer__container" } });
        // });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        AOS.init();

        // $(window).on('resize', function () {
        //   AOS.refresh();
        // });

        $(window).scroll(function () {
          if ($(this).scrollTop() > 50) {
            $('#up-button:hidden').stop(true, true).fadeIn();
          } else {
            $('#up-button').stop(true, true).fadeOut();
          }
        });

        if (window.innerWidth < 1024) {
          // console.log('mobile!');
          $(window).scroll(function () {
            if ($(this).scrollTop() > 35) {
              $('.header__logo').fadeOut();
              $('.header').css('position', 'fixed');
              $('.header__container').css('padding', '0.5em');
              $('.header__links').css('padding-top', '0');
            } else {
              $('.header__logo').fadeIn();
              $('.header').css('position', 'relative');
              $('.header__container').css('padding', '2em 0.5em');
              $('.header__links').css('padding-top', '1em');
            }
          });
        }

        $(function () {
          $("#up-button").click(function (e) {
            $('html, body').animate({ scrollTop: '0px' }, 800);
          })
        })

        if ($('.social_feed__slider').is(':visible')) {
          $(window).load(function () {
            var feed = new Instafeed({
              get: 'user',
              userId: '447262475',
              clientId: 'b2b5c55dc59544b49dfd8ccdd8fa31f7',
              accessToken: '447262475.b2b5c55.31a467249f7b481d98109765cd6fe306',
              target: 'social_feed__slider',
              template: '<div class="feed_slide"><a target="blank" href="{{link}}"><img src="{{image}}" alt="{{caption}}" /><div class="feed_slide__info"><div class="feed_slide__info--top_line"><p><svg width="25" height="25"><use xlink:href="#instagram" class="ig_icon"/></svg>thurmanortho</p><p>{{likes}} likes</p></div><p>{{caption}}</p></div></a></div>',
              resolution: 'standard_resolution',
              limit: 10,
              after: function () {
                $('.social_feed__slider').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  // variableWidth: true,
                  arrows: false,
                  dots: false,
                  pauseOnFocus: true,
                  pauseOnHover: true,
                  // autoplay: true,
                  // autoplaySpeed: 3000,
                  centerPadding: '0px',
                  slidesToShow: 3,
                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        arrows: false,
                        centerMode: false,
                        // centerPadding: '40px',
                        slidesToShow: 1
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: false,
                        centerMode: false,
                        // centerPadding: '40px',
                        slidesToShow: 1
                      }
                    }
                  ]
                });
              }
            });
            feed.run();
          })
        }

      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
        var controller = new ScrollMagic.Controller();

        var currentWindowWidth = window.innerWidth;

        // if (currentWindowWidth < 1024) {
        //   $('.home_office__photo').attr('data-aos-offset', 0);
        //   $('#home_doc__photo').attr('data-aos-offset', 400);
        // } else {
        //   $('.home_office__photo').attr('data-aos-offset', 400);
        //   $('#home_doc__photo').attr('data-aos-offset', 500);

        // }

        // if (currentWindowWidth < 1024) {
        //   $('.about_team__entry').attr('data-aos-offset', 350);
        // } else {
        //   $('.about_team__entry').attr('data-aos-offset', 700);
        // }

        $('.home_stories__mobile--slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          pauseOnFocus: true,
          pauseOnHover: true,
          autoplay: true,
          autoplaySpeed: 3000
        });

        $('.home_stories__mobile--cluster > a').magnificPopup({
          type: 'inline',
          midClick: true,
          closeBtnInside: true,
          fixedContentPos: true,
          callbacks: {
            open: function () {
              // var vid = this.container.context.children[0].children[0].children[0];
              // console.log(vid);
              // console.log(vid);
              this.container.context.children[0].children[0].children[0].play();
            },
            close: function () {
              var vid = $('video');
              var vidArray = Object.values(vid);
              // console.log(vidArray);
              vidArray.forEach(function (video) {
                if (video.tagName === 'VIDEO' && video.parentElement.className === "mfp-hide") {
                  video.pause();
                }
              })
            }
          }
        });

        $('.home_stories__cluster--line > a').magnificPopup({
          type: 'inline',
          midClick: true,
          closeBtnInside: true,
          fixedContentPos: true,
          callbacks: {
            open: function () {
              // var vid = this.container.context.children[0].children[0].children[0];
              // console.log(vid);
              // console.log('play!');
              this.container.context.children[0].children[0].children[0].play();
            },
            close: function () {
              var vid = $('video');
              var vidArray = Object.values(vid);
              // console.log(vidArray);
              vidArray.forEach(function (video) {
                if (video.tagName === 'VIDEO' && video.className === "story_video") {
                  video.pause();
                }
              })
            }
          }
        });

        // $('.mfp-container').on('click', function () {
        //   $('video').trigger('pause');
        // })

        new ScrollMagic.Scene({ triggerElement: ".home_hero__container", duration: 600, offset: 700 })
          .setClassToggle("#follow_logo", "reveal")
          .setPin("#follow_logo", { pushFollowers: false })
          // .addIndicators({ name: "1 (duration: 600)" })
          // .on("end", function (event) {
          //   $('.home_office__photo').addClass("reveal");
          // })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_hero__container", offset: 700 })
          .setClassToggle("#hero_logo", "hide")
          // .addIndicators({ name: "1.5 (duration: 750)" })
          .addTo(controller);

        // new ScrollMagic.Scene({ triggerElement: ".home_office__tour", duration: 225 })
        //   // .setClassToggle("#follow_logo", "reveal")
        //   .setPin(".home_office__tour", { pushFollowers: false })
        //   .addIndicators({ name: "2.1 (duration: 225)" })
        //   .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_callouts", offset: -200, reverse: false })
          .setClassToggle(".home_callouts__top_line", "animate")
          // .addIndicators({ name: "2" })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_stories", offset: -200, reverse: false })
          .setClassToggle(".home_stories__top_line", "animate")
          // .addIndicators({ name: "3" })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_stories", reverse: false })
          .setClassToggle(".home_stories__cluster--top_line", "animate")
          // .addIndicators({ name: "4" })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_stories", duration: 1250, offset: 300 })
          .setPin("#follow_logo2", { pushFollowers: false })
          // .addIndicators({ name: "5 (duration: 1250)" })
          .on("enter", function (event) {
            if (event.scrollDirection === "REVERSE") {
              $('#follow_logo2').toggleClass("reveal");
            }
          })
          .on("end", function (event) {
            if (event.scrollDirection === "REVERSE") {
              $('#follow_logo2').addClass("reveal");
            } else {
              $('#follow_logo2').removeClass("reveal");
            }
          })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_stories", offset: 300 })
          .setClassToggle("#follow_logo2", "reveal")
          .addTo(controller);

        var storyLink = $('.home_stories__cluster--link'),
          storyVid = $('.home_stories__cluster--image'),
          startStoryCluster = new TimelineMax({ delay: 0.5 })
            .from(storyLink, 0.25, { opacity: 0, scale: 0.1 })
            .from(storyVid, 1, { opacity: 0, scale: 0 });

        new ScrollMagic.Scene({ triggerElement: ".home_stories__title", offset: 200, reverse: false })
          .setClassToggle(".home_stories__cluster--line", "animate")
          // .addIndicators({ name: "6" })
          .setTween(startStoryCluster)
          .addTo(controller);

        // new ScrollMagic.Scene({ triggerElement: ".home_stories", duration: 750, offset: 900 })
        //   // .setPin("#follow_logo2", { pushFollowers: false })
        //   .addIndicators({ name: "5 (duration: 750)" })

        //   .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_appt_request", offset: -200, reverse: false })
          .setClassToggle(".home_appt_request__top_line", "animate")
          // .addIndicators({ name: "7" })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_appt_request", offset: -200, reverse: false })
          .setClassToggle(".home_appt_request__button", "draw_border_white")
          // .addIndicators({ name: "7" })
          .addTo(controller);

        new ScrollMagic.Scene({ triggerElement: ".home_location", offset: -200, reverse: false })
          .setClassToggle(".home_location__top_line", "animate")
          // .addIndicators({ name: "8" })
          .addTo(controller);

        var locationLeft = $('#icon-entry-left'),
          locationCenter = $('#icon-entry-center'),
          locationRight = $('#icon-entry-right');

        if (currentWindowWidth >= 1024) {
          var startLocationIcons = new TimelineMax({ delay: 1.5 })
            .from(locationCenter, 0.5, { opacity: 0 })
            .from(locationRight, 0.3, { opacity: 0 })
            .from(locationLeft, 0.3, { opacity: 0 }, '-=0.3');

          new ScrollMagic.Scene({ triggerElement: ".home_location", offset: -200, reverse: false })
            .setClassToggle(".home_location__top_icons--line", "animate")
            // .addIndicators({ name: "9" })
            .setTween(startLocationIcons)
            .addTo(controller);
        } else {
          var startLocationIcons = new TimelineMax({ delay: 0.5 })
            .from(locationLeft, 0.3, { opacity: 0 })
            .from(locationCenter, 0.3, { opacity: 0 })
            .from(locationRight, 0.3, { opacity: 0 });

          new ScrollMagic.Scene({ triggerElement: ".home_location", offset: -200, reverse: false })
            .setClassToggle(".home_location__top_icons--line", "animate")
            // .addIndicators({ name: "9" })
            .setTween(startLocationIcons)
            .addTo(controller);
        }



        new ScrollMagic.Scene({ triggerElement: ".home_location", offset: -200, reverse: false })
          .setClassToggle(".home_location__map_section--top_line", "animate")
          // .addIndicators({ name: "10" })
          .addTo(controller);

        var socialLeft = $('a#social-entry-left'),
          socialCenter = $('a#social-entry-center'),
          socialRight = $('a#social-entry-right'),
          startSocialIcons = new TimelineMax({ delay: 0.75 })
            .from(socialCenter, 0.4, { opacity: 0 })
            .from(socialRight, 0.15, { opacity: 0 })
            .from(socialLeft, 0.35, { opacity: 0 });

        new ScrollMagic.Scene({ triggerElement: ".home_location__map_section--link_wrapper", reverse: false })
          .setClassToggle(".home_location__social_links--line", "animate")
          // .addIndicators({ name: "11" })
          .setTween(startSocialIcons)
          .addTo(controller);

        // new ScrollMagic.Scene({ triggerElement: "#circle_trigger", duration: 150, offset: 800 })
        //   .setPin(".home_hero__logo")
        //   .addIndicators()
        //   .addTo(controller);

        // new ScrollMagic.Scene({ triggerElement: "#circle_trigger", duration: 150, offset: 1200 })
        //   .setPin(".home_hero__logo")
        //   .addIndicators()
        //   .addTo(controller);
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_about': {
      init: function () {
        // JavaScript to be fired on the about us page


        var about1 = document.getElementById("about_button1"),
          about2 = document.getElementById("about_button2"),
          about3 = document.getElementById("about_button3"),
          about4 = document.getElementById("about_button4");

        about1.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#services" } });
        }

        about2.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#doctor" } });
        }

        about3.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#team" } });
        }

        about4.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#community" } });
        }

        var currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < 1024) {
          $('.about_team__entry').attr('data-aos-offset', 350);
        } else {
          $('.about_team__entry').attr('data-aos-offset', 700);
        }

        var controller2 = new ScrollMagic.Controller();

        new ScrollMagic.Scene({ triggerElement: ".appt_request", offset: -200, reverse: false })
          .setClassToggle(".appt_request__top_line", "animate")
          // .addIndicators({ name: "7" })
          .addTo(controller2);

        var communityTimeline = new TimelineMax()
          .staggerFrom(".about_community__image", 2, {
            scale: 0, delay: 0.25, ease: Bounce.easeOut
          }, 0.25);

        new ScrollMagic.Scene({
          triggerElement: ".about_community__container",
          reverse: false
        })
          .setTween(communityTimeline)
          // .addIndicators({ name: "logo timeline" })
          .addTo(controller2);

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Patients page template
    'page_template_template_patients': {
      init: function () {
        // JavaScript to be fired on the about us page
        var patients1 = document.getElementById("patients_button1"),
          patients2 = document.getElementById("patients_button2"),
          patients3 = document.getElementById("patients_button3");

        patients1.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#process" } });
        }

        patients2.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#financial" } });
        }

        patients3.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#forms" } });
        }

        var controller3 = new ScrollMagic.Controller();

        new ScrollMagic.Scene({ triggerElement: ".appt_request", offset: -200, reverse: false })
          .setClassToggle(".appt_request__top_line", "animate")
          // .addIndicators({ name: "7" })
          .addTo(controller3);

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Treatment page template
    'page_template_template_treatment': {
      init: function () {
        // JavaScript to be fired on the about us page
        var treatment1 = document.getElementById("treatment_button1"),
          treatment2 = document.getElementById("treatment_button2"),
          treatment3 = document.getElementById("treatment_button3"),
          treatment4 = document.getElementById("treatment_button4"),
          treatment5 = document.getElementById("treatment_button5");

        treatment1.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#treatment_options" } });
        }

        treatment2.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#treatment_kids" } });
        }

        treatment3.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#treatment_teens" } });
        }

        treatment4.onclick = function () {
          TweenMax.to(window, 2, { scrollTo: { y: "#treatment_adults" } });
        }

        treatment5.onclick = function () {
          console.log("clicked");
          TweenMax.to(window, 2, { scrollTo: { y: "#faq" } });
        }

        var controller4 = new ScrollMagic.Controller();

        new ScrollMagic.Scene({ triggerElement: ".appt_request", offset: -200, reverse: false })
          .setClassToggle(".appt_request__top_line", "animate")
          // .addIndicators({ name: "7" })
          .addTo(controller4);

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Invisalign page template
    'page_template_template_invisalign': {
      init: function () {
        // JavaScript to be fired on the about us page

        var currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < 1024) {
          $('.invisalign_callouts__desc_box').attr('data-aos', 'fade');
        }

        var controller5 = new ScrollMagic.Controller();

        new ScrollMagic.Scene({ triggerElement: ".appt_request", offset: -300, reverse: false })
          .setClassToggle(".appt_request__top_line", "animate")
          // .addIndicators({ name: "7" })
          .addTo(controller5);

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
